const POST_TYPES = {
    FETCH_POSTS: 'FETCH_POSTS'
}

export default POST_TYPES;